var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGethelpIconsQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69351_5246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C10.287 28 6.72601 26.525 4.1005 23.8995C1.475 21.274 0 17.713 0 14C0 10.287 1.475 6.72601 4.1005 4.1005C6.72601 1.475 10.287 0 14 0C17.713 0 21.274 1.475 23.8995 4.1005C26.525 6.72601 28 10.287 28 14C28 17.713 26.525 21.274 23.8995 23.8995C21.274 26.525 17.713 28 14 28ZM16.8 9.8C16.8 10.192 16.506 10.92 16.212 11.2L14 13.412C13.202 14.224 12.6 15.652 12.6 16.8V18.2H15.4V16.8C15.4 16.394 15.694 15.68 15.988 15.4L18.2 13.188C18.998 12.376 19.6 10.948 19.6 9.8C19.6 8.31479 19.01 6.89041 17.9598 5.8402C16.9096 4.79 15.4852 4.2 14 4.2C12.5148 4.2 11.0904 4.79 10.0402 5.8402C8.99 6.89041 8.4 8.31479 8.4 9.8H11.2C11.2 9.05739 11.495 8.3452 12.0201 7.8201C12.5452 7.295 13.2574 7 14 7C14.7426 7 15.4548 7.295 15.9799 7.8201C16.505 8.3452 16.8 9.05739 16.8 9.8ZM12.6 21V23.8H15.4V21H12.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69351_5246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGethelpIconsQuestion);
export default __webpack_public_path__ + "static/media/GethelpIconsQuestion.e504191c9026ca18da39408bfdc2499e.svg";
export { ForwardRef as ReactComponent };